import { useMemo } from "react"
import { Case } from "@/types"

// Page size configurations for different views
export const PAGE_SIZE_CONFIG = {
	RELEVANT_DOCS: 6,
	ALL_DOCS_TREE: 6,
	ALL_DOCS_LIST: 10,
}

/**
 * Hook to determine pagination configuration for a case
 * Always enables pagination for better scalability
 */
export const useCaseDocumentsPagination = (caseData: Case | undefined) => {
	return useMemo(() => {
		if (!caseData) return { shouldPaginate: true, documentCount: 0 }
		
		const documentCount = caseData.document_count
		
		return {
			shouldPaginate: true, // Always paginate for consistency and performance
			documentCount,
			pageSizeConfig: PAGE_SIZE_CONFIG
		}
	}, [caseData])
}